import React from 'react';
import { Radio, ExternalLink } from 'lucide-react';
import { Badge } from '../../ui/Badge';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

interface Service {
  port: number;
  protocol: string;
  service: string;
  version: string;
  status: string;
}

interface AssetServicesProps {
  services: any;
}

export const AssetServices: React.FC<AssetServicesProps> = ({ services }) => {
  const navigate = useNavigate();
  return (
    <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-2">
          <Radio className="h-5 w-5 text-blue-500" />
          <h2 className="text-lg font-semibold text-white">Services</h2>
        </div>
        <span className="text-sm text-gray-400">{services.length} services detected</span>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {services.map((service: any, index: number) => (
          <div
            key={index}
            className="flex items-center justify-between p-4 bg-gray-800/30 rounded-lg group hover:bg-gray-800/50"
          >
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 cursor-pointer" onClick={() => navigate(`/ports/${service.id}`)}>
                <span className="text-sm font-medium text-white">Port {service.number}</span>
                <span className="text-sm text-gray-400">{service.protocol.toUpperCase()}</span>
              </div>
              <div className="h-4 w-px bg-gray-700" />
              <div>
                <div className="text-sm font-medium text-white">{service.service.toUpperCase()}</div>
                <div className="text-xs text-gray-400">{service.version}</div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <Badge variant={service.state as any}>{service.state}</Badge>
              <Link
                      to={`/ports/${service.id}`}
                      className="bg-[#1A1F2E] text-white"
                    >
                      <ExternalLink className="h-4 w-4" />
                    </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};